import React, { FC } from 'react';
import { UploaderProps } from './Uploader';
import clsx from 'clsx';
import vector from './assets/vector.png';

const Vector: FC<Pick<UploaderProps, 'type'>> = ({ type }) => {
  if (type === 'order-service' || type === 'inventory')
    return (
      <div
        className={clsx(
          'pointer-events-none absolute -left-[60px] -right-[350px] rotate-[12deg] md:-left-[80px] md:-right-[450px] lg:-left-[100px] lg:-right-[500px] xl:-left-[120px] xl:-right-[580px]',
          {
            '-top-[130px] md:-top-[330px] lg:-top-[400px] xl:-top-[540px]':
              type === 'order-service',
            '-top-[220px] md:-top-[280px] lg:-top-[320px] xl:-top-[360px]':
              type === 'inventory',
          },
        )}
      >
        <img src={vector} className="h-full w-full opacity-50" />
      </div>
    );
  else return null;
};

export default Vector;
